export default __webpack_public_path__ + "static/media/ind4.062c662f.jpg";